import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import styles from "./AdminLayout.module.scss";
import QreativesLogo from "components/common/QreativesLogo/QreativesLogo";
import NoImageSVG from "components/SVGComponents/NoImageSVG";
import { sidebarLinks } from "components/admin/constants";
import ErrorBoundary from "components/errorboundary/Errorboundary";

const MenuIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 7h16M4 12h16M4 17h16"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const AdminLayout = () => {
  const { pathname } = useLocation();
  const pathName = pathname.slice(1).split("-").join(" ") || "Admin Panel";
  const [profileModal, setProfileModal] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    setNavOpen(false);
    setProfileModal(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = navOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [navOpen]);

  return (
    <div
      onClick={() => {
        setProfileModal(false);
      }}
      className={styles.main}
    >
      {navOpen && (
        <button
          type="button"
          className={styles.backdrop}
          aria-label="Close menu"
          onClick={() => setNavOpen(false)}
        />
      )}
      <aside className={`${styles.sidebar} ${navOpen ? styles.open : ""}`}>
        <div className={styles.sidebarHead}>
          <QreativesLogo
            href={"/dashboard"}
            className={styles.logoLink}
            width="128"
            height="40"
          />
          <button
            type="button"
            className={styles.closeBtn}
            aria-label="Close menu"
            onClick={() => setNavOpen(false)}
          >
            ×
          </button>
        </div>
        <div className={styles.sidebarLinks}>
          {sidebarLinks.map((link) => (
            <NavLink key={link.to} to={link.to} className={styles.sidebarLink}>
              {link.icon}
              <p>{link.label}</p>
            </NavLink>
          ))}
        </div>
      </aside>
      <section className={styles.rightSide}>
        <div className={styles.profile}>
          <button
            type="button"
            className={styles.menuBtn}
            aria-label="Open menu"
            onClick={(e) => {
              e.stopPropagation();
              setNavOpen(true);
            }}
          >
            <MenuIcon />
          </button>
          <div className={styles.profileImg}>
            <span
              onClick={(e) => {
                e.stopPropagation();
                setProfileModal((prev) => !prev);
              }}
            >
              <NoImageSVG />
            </span>
            {profileModal && (
              <div className={styles.profileModal}>
                <button onClick={handleLogout}>Logout</button>
              </div>
            )}
          </div>
        </div>
        <div className={styles.navbar}>
          <h1>{pathName}</h1>
        </div>
        <div className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </section>
    </div>
  );
};

export default AdminLayout;
